import { render, staticRenderFns } from "./OrderCustomerInfo.vue?vue&type=template&id=3d592cb9&scoped=true&"
import script from "./OrderCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./OrderCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d592cb9",
  null
  
)

export default component.exports